import styled from 'styled-components';
import { variables } from '@splunk/themes';
import React, { ReactNode, useContext } from 'react';
import { SignalviewTopNavContext } from '../TopNavContextProvider';
import { PageHeader, PageHeaderProps } from '@splunk/olly-react-ui/lib/PageHeader';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../common/theme/ThemeProvider';

/**
 *  Override .sf-bootstrap styles
 */
export const StyledPageHeaderWrapper = styled.div`
    color: ${variables.contentColorActive};
    a:not([disabled], [aria-disabled='true']) {
        :focus:not(:hover) {
            color: ${variables.contentColorDefault};
        }
        color: ${variables.contentColorDefault};
    }
`;

const StyledPageHeader = styled(PageHeader)`
    h1 {
        font-size: ${variables.fontSizeXLarge};
        font-weight: ${variables.fontWeightBold};
        margin: 0;
        padding: 0;
    }
`;

export type PageHeaderWrapperProps = Pick<PageHeaderProps, 'description' | 'navigation'> & {
    rightContent?: ReactNode;
    titleContent?: ReactNode;
    className?: string;
};

export const PageHeaderWrapper = ({
    description,
    navigation: customNavigation,
    rightContent,
    titleContent,
    className,
}: PageHeaderWrapperProps): React.JSX.Element => {
    const themeKey = useLegacyThemeServiceKey();
    const { navigation } = useContext(SignalviewTopNavContext);

    return (
        <ThemeProvider colorScheme={themeKey}>
            <StyledPageHeaderWrapper className={className}>
                <StyledPageHeader
                    density="compact"
                    description={description}
                    navigation={customNavigation ?? navigation}
                    rightContent={rightContent}
                    titleContent={titleContent}
                />
            </StyledPageHeaderWrapper>
        </ThemeProvider>
    );
};
